import "@mdi/font/css/materialdesignicons.css";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";

Vue.config.productionTip = process.env.NODE_ENV === "production";

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
